export default {
  error_messages: {
    orders_disabled: 'Tilaaminen täällä ei ole tällä hetkellä mahdollista',
  },
};
